const host = 'https://intranet.cima.com.pe:8443/api/school';
// const host = 'http://localhost:3000/api/school';
//const host = 'http://192.168.70.13:3000/api/school';
const token = '186792bf11c51e92ed5eba02424312ac';

export {host,token}


// WEBPACK FOOTER //
// ./src/cfg/core.js